import { ReactNode } from "react";

import { Box, useBreakpointValue } from "@/storybook-components";
import StickyActionBar from "./sticky-action-bar";

function RowLayout({
  aboutContent,
  mainContent,
  actions,
  splitActions
}: {
  aboutContent: ReactNode;
  mainContent: ReactNode;
  actions?: { component: ReactNode; position: "left" | "right" }[];
  splitActions?: boolean;
}) {
  const isMobile = useBreakpointValue({ base: true, lg: false }) || false;

  return (
    <Box px={{ base: 4, md: 6 }} py={4}>
      <Box className="ehq-aboutContent">{aboutContent}</Box>
      <Box
        position="relative"
        mt={{ base: 4, lg: 0 }}
        className="ehq-mainContent"
      >
        {isMobile ? (
          <>
            {mainContent}
            <Box mt={4} position="sticky" bottom={0} zIndex={10}>
              <StickyActionBar actions={actions} splitActions={splitActions} />
            </Box>
          </>
        ) : (
          <>
            <Box mb={4} position="sticky" top={0} zIndex={10}>
              <StickyActionBar actions={actions} splitActions={splitActions} />
            </Box>
            {mainContent}
          </>
        )}
      </Box>
    </Box>
  );
}

export default RowLayout;
